const countryFlags = {
	Brasil: "🇧🇷",
	Argentina: "🇦🇷",
	Uruguai: "🇺🇾",
	Paraguai: "🇵🇾",
	"Bolívia": "🇧🇴",
	Chile: "🇨🇱",
	Peru: "🇵🇪",
	Equador: "🇪🇨",
	"Colômbia": "🇨🇴",
	Venezuela: "🇻🇪",
	Suriname: "🇸🇷",
	Guiana: "🇬🇾",
	"Guiana Francesa": "🇬🇫",
	México: "🇲🇽",
	"Estados Unidos": "🇺🇸",
	Canadá: "🇨🇦",
	Espanha: "🇪🇸",
	Portugal: "🇵🇹",
	Itália: "🇮🇹",
	França: "🇫🇷",
	Alemanha: "🇩🇪",
	China: "🇨🇳",
	Japão: "🇯🇵",
	"Coreia do Sul": "🇰🇷",
	Índia: "🇮🇳",
	Austrália: "🇦🇺",
	"Reino Unido": "🇬🇧",
	"Países Baixos": "🇳🇱",
	Bélgica: "🇧🇪",
	Suíça: "🇨🇭",
	Áustria: "🇦🇹",
	Polônia: "🇵🇱",
	"República Tcheca": "🇨🇿",
	Grécia: "🇬🇷",
	Turquia: "🇹🇷",
	Rússia: "🇷🇺",
	Ucrânia: "🇺🇦",
	Egito: "🇪🇬",
	Marrocos: "🇲🇦",
	Tunísia: "🇹🇳",
	Argélia: "🇩🇿",
	"Arábia Saudita": "🇸🇦",
	"Emirados Árabes Unidos": "🇦🇪",
	Catar: "🇶🇦",
	Kuwait: "🇰🇼",
	Jordânia: "🇯🇴",
	Líbano: "🇱🇧",
	Síria: "🇸🇾",
	Iraque: "🇮🇶",
	Irã: "🇮🇷",
	Palestina: "🇵🇸",
	Israel: "🇮🇱",
	Oman: "🇴🇲",
	Iêmen: "🇾🇪",
	"Nova Zelândia": "🇳🇿",
	Fiji: "🇫🇯",
	"Papua-Nova Guiné": "🇵🇬",
	Indonésia: "🇮🇩",
	Filipinas: "🇵🇭",
	Tailândia: "🇹🇭",
	Vietnã: "🇻🇳",
	Malásia: "🇲🇾",
	Singapura: "🇸🇬",
	Camboja: "🇰🇭",
	Laos: "🇱🇦",
	Mianmar: "🇲🇲",
	Brunei: "🇧🇳",
	"Timor-Leste": "🇹🇱",
	Islândia: "🇮🇸",
	Noruega: "🇳🇴",
	Dinamarca: "🇩🇰",
	Suécia: "🇸🇪",
	Finlândia: "🇫🇮",
	Irlanda: "🇮🇪",
	Escócia: "🏴",
	"País de Gales": "🏴",
	Hungria: "🇭🇺",
	Romênia: "🇷🇴",
	Bulgária: "🇧🇬",
	Sérvia: "🇷🇸",
	Croácia: "🇭🇷",
	Eslovênia: "🇸🇮",
	Eslováquia: "🇸🇰",
	Lituânia: "🇱🇹",
	Letônia: "🇱🇻",
	Estônia: "🇪🇪",
	"Bosnia e Herzegovina": "🇧🇦",
	Montenegro: "🇲🇪",
	Kosovo: "🇽🇰",
	"Macedônia do Norte": "🇲🇰",
	Albania: "🇦🇱",
	Gibraltar: "🇬🇮",
	Malta: "🇲🇹",
	Chipre: "🇨🇾",
	Bielorrússia: "🇧🇾",
	Moldova: "🇲🇩",
	Afeganistão: "🇦🇫",
	Paquistão: "🇵🇰",
	Bangladesh: "🇧🇩",
	"Sri Lanka": "🇱🇰",
	Nepal: "🇳🇵",
	Butão: "🇧🇹",
	Maldivas: "🇲🇻",
	Tajiquistão: "🇹🇯",
	Quirguistão: "🇰🇬",
	Uzbequistão: "🇺🇿",
	Turcomenistão: "🇹🇲",
	Mongólia: "🇲🇳",
	"Coreia do Norte": "🇰🇵",
	Cuba: "🇨🇺",
	Haiti: "🇭🇹",
	"República Dominicana": "🇩🇴",
	Jamaica: "🇯🇲",
	"Trindade e Tobago": "🇹🇹",
	Bahamas: "🇧🇸",
	Barbados: "🇧🇧",
	Granada: "🇬🇩",
	"Santa Lucia": "🇱🇨",
	"São Vicente e Granadinas": "🇻🇨",
	"Antígua e Barbuda": "🇦🇬",
	Dominica: "🇩🇲",
	"São Cristóvão e Nevis": "🇰🇳",
	Etiópia: "🇪🇹",
	Quênia: "🇰🇪",
	Uganda: "🇺🇬",
	Ruanda: "🇷🇼",
	Burundi: "🇧🇮",
	Tanzania: "🇹🇿",
	Zambia: "🇿🇲",
	Zimbabwe: "🇿🇼",
	Malawi: "🇲🇼",
	Botswana: "🇧🇼",
	Namíbia: "🇳🇦",
	Lesotho: "🇱🇸",
	Suazilandia: "🇸🇿",
};

function getTwemojiUrlFromEmoji(emoji) {
	if (!emoji) return "";
	const codepoints = Array.from(emoji)
		.map((char) => char.codePointAt(0).toString(16))
		.join("-");
	return `https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${codepoints}.svg`;
}

export function getFlagByCountryName(countryName) {
	return countryFlags[countryName] || "";
}

export function getFlagUrlByCountryName(countryName) {
	const emoji = getFlagByCountryName(countryName);
	return getTwemojiUrlFromEmoji(emoji);
}

export default countryFlags;
